import { render } from "./SankeyChart.vue?vue&type=template&id=e5f370da&scoped=true"
import script from "./SankeyChart.vue?vue&type=script&lang=js"
export * from "./SankeyChart.vue?vue&type=script&lang=js"

import "./SankeyChart.vue?vue&type=style&index=0&id=e5f370da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f370da"]])

export default __exports__